import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import useOrderRefundPaymentModal from './hooks/useOrderRefundPaymentModal';

interface OrderRefundPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  orderId: string;
  orderCode: string;
  onSuccess?: () => void;
}

const OrderRefundPaymentModal = ({
  isOpen,
  onClose,
  orderCode,
  orderId,
  onSuccess,
}: OrderRefundPaymentModalProps) => {
  const { translate } = useTranslation();

  const { handleRefundPayment, isSubmitting, refundLimitHours } = useOrderRefundPaymentModal({
    onClose,
    orderId,
    onSuccess,
  });

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: translate(LangEnum.PAYMENT_LINK_REFUND_CONFIRMATION_TITLE) }}
      onClose={onClose}
      footer={{
        primaryAction: {
          label: translate(LangEnum.PAYMENT_LINK_REFUND_BUTTON_LABEL),
          onClick: handleRefundPayment,
          isDisabled: isSubmitting,
        },
        secondaryAction: {
          label: translate(LangEnum.GLOBAL_GO_BACK),
          onClick: onClose,
          isDisabled: isSubmitting,
        },
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {translate(LangEnum.PAYMENT_LINK_REFUND_CONFIRMATION_DESCRIPTION, {
          orderCode,
          hours: refundLimitHours,
        })}
      </Typography>
    </Modal>
  );
};

export default OrderRefundPaymentModal;
